import { render } from "./Checkbox.vue?vue&type=template&id=6cddaea5&scoped=true&ts=true"
import script from "./Checkbox.vue?vue&type=script&lang=ts"
export * from "./Checkbox.vue?vue&type=script&lang=ts"

import "../assets/scss/checkbox.scss?vue&type=style&index=0&id=6cddaea5&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cddaea5"]])

export default __exports__